"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
interface EarthCloudsProps {
  cloudsMap: THREE.Texture;
  initialRotation: number;
  rotationSpeed: number;
}
export default function EarthClouds(t0) {
  const $ = _c(8);
  const {
    cloudsMap,
    initialRotation,
    rotationSpeed
  } = t0;
  const meshRef = useRef(null);
  let t1;
  if ($[0] !== rotationSpeed) {
    t1 = (_state, delta) => {
      if (!meshRef.current) {
        return;
      }
      meshRef.current.rotateY(delta * 1000 * rotationSpeed);
    };
    $[0] = rotationSpeed;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useFrame(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <sphereGeometry args={[10.05, 64, 64]} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cloudsMap) {
    t3 = <meshStandardMaterial alphaMap={cloudsMap} transparent={true} />;
    $[3] = cloudsMap;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== initialRotation || $[6] !== t3) {
    t4 = <mesh ref={meshRef} rotation-y={initialRotation}>{t2}{t3}</mesh>;
    $[5] = initialRotation;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}